import { TaggedError } from "@for-it/domain-lib";
export class CompanyNotFoundError extends TaggedError {
    constructor() {
        super("CompanyNotFoundError");
    }
}
